import {
  ComponentClass,
  FunctionComponent,
  lazy,
  LazyExoticComponent,
} from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProtectedRoute from 'router/ProtectedRoute';

interface IRoutesProps {
  path: string;
  component: FunctionComponent | ComponentClass | LazyExoticComponent<any>;
  exact?: boolean;
  protected?: boolean;
}

const Home = lazy(() => import('pages/Home'));
const Inspection = lazy(() => import('pages/Inspection'));
const Checklist = lazy(() => import('pages/Checklist'));
const RepairSymptoms = lazy(() => import('pages/RepairSymptoms'));
const PossibleRepairs = lazy(() => import('pages/PossibleRepairs'));
const Summary = lazy(() => import('pages/Summary'));
const SelectInspectionType = lazy(() => import('pages/SelectInspectionType'));
const AuthCallback = lazy(() => import('pages/AuthCallback'));

const routesObj: IRoutesProps[] = [
  {
    path: '/mpi/create',
    protected: true,
    component: SelectInspectionType,
  },
  {
    path: '/mpi/:inspectionId/possible-repairs/:inspectionCategoryId/components/:inspectionComponentId/repairs/:repairId',
    protected: true,
    component: RepairSymptoms,
  },
  {
    path: '/mpi/:inspectionId/possible-repairs/:inspectionCategoryId/repairs/:repairId',
    protected: true,
    component: RepairSymptoms,
  },
  {
    path: '/mpi/:inspectionId/create-custom-request',
    protected: true,
    component: RepairSymptoms,
  },
  {
    path: '/mpi/:inspectionId/repairs/:repairId',
    protected: true,
    component: RepairSymptoms,
  },
  {
    path: '/mpi/:inspectionId/repair-symptoms/:inspectionResultId',
    protected: true,
    component: RepairSymptoms,
  },
  {
    path: '/mpi/:inspectionId/possible-repairs/:inspectionCategoryId',
    protected: true,
    component: PossibleRepairs,
  },
  {
    path: '/mpi/:inspectionId/summary',
    protected: true,
    component: Summary,
  },
  {
    path: '/mpi/checklist/:inspectionId',
    protected: true,
    component: Checklist,
  },
  {
    path: '/mpi/:inspectionId',
    protected: true,
    component: Inspection,
  },
  {
    path: '/auth',
    component: AuthCallback,
  },
  {
    path: '/',
    protected: true,
    component: Home,
  },
];

const Routes = () => (
  <Switch>
    {/* Redirect legacy /sign-in to /auth */}
    <Redirect from="/sign-in" to="/auth" />
    {routesObj.map((route) =>
      route.protected ? (
        <ProtectedRoute
          key={route.path}
          path={route.path}
          component={route.component}
          exact={route.exact}
        />
      ) : (
        <Route
          key={route.path}
          path={route.path}
          component={route.component}
          exact={route.exact}
        />
      )
    )}
  </Switch>
);

export default Routes;
